import Link from "next/link";

const Link_Arrow_Btn = ({ link, text, customClass, target = "_blank" }) => {
  return (
    <Link
      href={link ?? ''}
      target="_blank"
      className={`${customClass && customClass
        } flex items-center justify-between`}
    // target={target}
    >
      <span className="block align-top">{text && text}</span>
      <span className="block align-top ms-5 lg:ms-[1.5vw]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="w-[15px] lg:w-[1vw]"
        >
          <path
            d="M16.9619 10.667L9.2388 18.3901L10.1901 19.3337L19.5234 10.0003L10.1901 0.666992L9.2388 1.61059L16.9619 9.33366H0.856771V10.667H16.9619Z"
            fill="#212121"
          />
        </svg>
      </span>
    </Link>
  );
};

export default Link_Arrow_Btn;
